export const RESET_STATE = 'ERP_RESET_STATE';
export const CURRENT_ITEM = 'ERP_CURRENT_ITEM';

export const REQUEST_LOADING = 'ERP_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'ERP_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'ERP_REQUEST_FAILED';

export const CURRENT_ACTION = 'ERP_CURRENT_ACTION';
export const RESET_ACTION = 'ERP_RESET_ACTION';